
























import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class BaseHeader extends Vue {
  @Prop({ default: "" }) headerText!: string;
}
